import { render, staticRenderFns } from "./TournamentRegister.vue?vue&type=template&id=4b3536f2&scoped=true"
import script from "./TournamentRegister.vue?vue&type=script&lang=js"
export * from "./TournamentRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3536f2",
  null
  
)

export default component.exports